<template>
    <div class="land-layout-container">
        <Header />
        <div id="qifu-common-header_of_sdk"></div>
        <div class="land-layout-content">
            <slot name="buy">
                <div class="product-buy-slot"></div>
            </slot>
            <slot name="intro">
                <div class="product-intro-slot"></div>
            </slot>
            <Requirement :name="name" :type="type"/>
        </div>
        <company-banner />
        <Footer />
    </div>
</template>

<script>
import Header from './Header.vue';
import CompanyBanner from './CompanyBanner.vue';
import Footer from './Footer.vue';
import Requirement from './Requirement.vue';
export default {
    props: ['type', 'name'],
    name: 'Home',
    components: {
        Header,
        CompanyBanner,
        Footer,
        Requirement
    }
}
</script>

<style lang="less" scoped>
.land-layout-container {
    background: #F5F5F5;
    .land-layout-content {
        width: 1200px;
        margin: 20px auto 80px;
        position: relative;
    }
    .product-buy-slot {
        width: 930px;
        height: 501px;
        background: #FFFFFF;
        margin-bottom: 16px;
    }
    .product-intro-slot {
        width: 930px;
        height: 501px;
        background: #FFFFFF;
    }
}
</style>
